

document.addEventListener('DOMContentLoaded', function() {
    const parents = document.querySelectorAll('[hover-variant-select-parent]');
    const children = document.querySelectorAll('[hover-variant-select]');

    parents.forEach((parent, index) => {
        parent.addEventListener('mouseover', function() {
            children[index].classList.add('open');
        })

        parent.addEventListener('mouseout', function() {
            children[index].classList.remove('open');
        })
    })

    const variantOptions = document.querySelectorAll('[hover-variant-select] [variant-option]');
    variantOptions.forEach((option) => {
        option.addEventListener('click', function() {
            const img = option.closest('[hover-variant-select-parent]').closest('cart-form').querySelector('img[js-product-featured-image]');
            const newSrc = option.getAttribute('data-featured-image');
            img.src = newSrc;
        })
    })
})
